// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1hzxV","name":"ConsentHeader_name__2xJWi","birthday":"ConsentHeader_birthday__3ZY69","skeleton":"ConsentHeader_skeleton__2O1cf"};